import { cva, type RecipeVariantProps } from '@/styled-system/css';
import { css } from '@/styled-system/css';

export const containerGridRecipe = cva({
  base: {
    borderRadius: '100',
    display: 'grid',
  },
  variants: {
    includeWhiteBackground: {
      true: {
        // oxlint-disable-next-line constellation/no-raw-color-values
        backgroundColor: 'white',
      },
      false: {
        backgroundColor: 'transparent',
      },
    },
    noPadding: {
      true: {
        padding: '0',
      },
      false: {
        padding: { base: '{spacing.1000} {spacing.400}', md: '{spacing.1000} {spacing.600}', xl: '1000' },
      },
    },
    includeMargin: {
      true: {
        marginBlock: '600',
      },
      false: {
        margin: { base: '0 -16px', md: '0' },
      },
    },
  },
  defaultVariants: {
    includeWhiteBackground: false,
    noPadding: false,
    includeMargin: false,
  },
});

export type ContainerGridVariants = RecipeVariantProps<typeof containerGridRecipe>;

export const gridRecipe = cva({
  base: {
    alignContent: 'start',
    display: 'grid',
  },
  variants: {
    noOverflow: {
      true: {
        overflow: 'visible',
      },
      false: {
        overflow: 'hidden',
      },
    },
  },
  defaultVariants: {
    noOverflow: false,
  },
});

export type GridVariants = RecipeVariantProps<typeof gridRecipe>;

export const hrRecipe = cva({
  base: {
    borderBottom: '1px solid {colors.border.subtle}',
    borderRight: 'none',
    marginBottom: '800',
  },
});

export const legendStyles = css.raw({
  display: 'flex',
  flexDirection: { base: 'column', xxl: 'row' },
  paddingTop: '400',
  paddingLeft: { base: '800', xxl: '60px' },
});

export const middleLegendSpacerStyles = css.raw({
  borderRadius: '50',
  margin: { xxl: '0 {spacing.400}' },
});

export const flexEndLegendStyles = css.raw({
  display: 'flex',
  justifyContent: { base: 'flex-start', xxl: 'flex-end' },
  marginTop: { base: '600', xxl: 'zero' },
  marginLeft: { xxl: 'auto' },
});

export const legendKeyStyles = css.raw({
  borderRadius: '50',
  // oxlint-disable-next-line constellation/no-raw-spacing-values
  width: '20px',
  marginRight: { base: '100', lg: '200' },
});

export const circleStyles = css.raw({
  borderRadius: '100',
  display: 'block',
  height: '200',
  lineHeight: '8px',
  width: '200',
});

export const compsLegendStyles = css.raw({
  // oxlint-disable-next-line constellation/no-raw-spacing-values
  height: '3px',
  // oxlint-disable-next-line constellation/no-raw-spacing-values
  width: '19px',
  borderRadius: '1px',
  marginRight: { base: '200', md: '100', xl: '200' },
  backgroundColor: 'bg.accent.yellow.soft',
});
